module.exports = __webpack_public_path__ + "static/media/-ve2.67226267.png";